import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ShieldCheck, TrendingUp, Phone, CheckCircle2, Sparkles, ArrowRight, Flame } from "lucide-react";
import { api } from "@/lib/api";

const CONTENTS = [
  "22 fattori del tuo immobile spiegati uno per uno — incidono fino al 40% del valore",
  "Grafico dei prezzi OMI ufficiali della tua zona (Agenzia delle Entrate)",
  "Calcolo 100% trasparente: ogni premio e malus tradotto in euro",
  "Strategia di vendita: prezzo di uscita, valore obiettivo, minimo difendibile",
  "La pagina che nessuno ti mostra: i 6 rischi del vendere da solo",
  "Call di 30 minuti inclusa con un consulente Gruppo Vela — la prenoti tu online",
];

export default function PremiumSection() {
  const [offer, setOffer] = useState(null);
  const launch = !!offer?.active;
  const price = launch ? offer.price_eur : 279;

  useEffect(() => {
    api.get("/premium-offer").then(({ data }) => setOffer(data)).catch(() => {});
  }, []);

  return (
    <section id="premium" className="relative py-24 lg:py-32 bg-[#0b2545] overflow-hidden" data-testid="premium-section">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full bg-[#14B8A6]/10 blur-3xl" />
        <div className="absolute -bottom-32 -right-32 w-[420px] h-[420px] rounded-full bg-[#A9D6E5]/10 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-y-12 gap-x-2 md:gap-10 lg:gap-16 items-center">
          {/* Copy */}
          <div className="col-span-12 lg:col-span-7">
            <div className="enea-eyebrow flex items-center gap-3 mb-5 text-[#14B8A6]">
              <Sparkles className="w-4 h-4" />
              <span className="text-[#A9D6E5]">07 · Valutazione Premium ENEA</span>
            </div>
            {launch && (
              <div className="mb-5 inline-flex items-center gap-2.5 rounded-full bg-amber-500/15 border border-amber-400/50 px-4 py-2 text-sm font-bold text-amber-300" data-testid="premium-launch-banner">
                <Flame className="w-4 h-4" />
                🔥 Offerta lancio: rimasti {offer.remaining} posti su {offer.quota} a €{offer.price_eur}
              </div>
            )}
            {offer && !launch && (
              <div className="mb-5 inline-flex items-center gap-2.5 rounded-full bg-white/10 border border-white/25 px-4 py-2 text-sm font-semibold text-[#A9D6E5]" data-testid="premium-standard-banner">
                Prezzo standard: €279
              </div>
            )}
            <h2 className="text-3xl lg:text-4xl xl:text-[44px] font-display font-semibold leading-tight text-white">
              Non un numero.
              <span className="block mt-2 text-[#14B8A6] font-medium">La spiegazione di ogni euro.</span>
            </h2>
            <p className="mt-6 text-[#A9D6E5]/90 leading-relaxed max-w-xl">
              Con <b className="text-white">€{price} IVA inclusa</b>{launch && <span className="text-[#A9D6E5]/70 line-through ml-1">€279</span>} ricevi via email una brochure di oltre 10 pagine
              che spiega, fattore per fattore, <b className="text-white">perché il tuo immobile vale quello che vale</b> —
              il documento con cui difendere il prezzo davanti a qualsiasi acquirente.
            </p>
            <ul className="mt-8 space-y-3">
              {CONTENTS.map((t) => (
                <li key={t} className="flex items-start gap-3 text-sm text-white/90">
                  <CheckCircle2 className="w-4 h-4 text-[#14B8A6] flex-shrink-0 mt-0.5" />
                  {t}
                </li>
              ))}
            </ul>
            <div className="mt-9 flex flex-wrap items-center gap-3">
              <Link to="/valutazione?premium=1"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-lg bg-[#14B8A6] text-[#06202b] text-sm font-bold hover:bg-[#2dd4bf] shadow-lg shadow-[#14B8A6]/25 transition"
                data-testid="premium-section-cta">
                Richiedi la Valutazione Premium — €{price} IVA inclusa
                <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/valutazione"
                className="inline-flex items-center gap-2 px-5 py-3.5 rounded-lg border border-white/25 text-white/85 text-sm font-medium hover:border-[#14B8A6] hover:text-white transition"
                data-testid="premium-section-free-cta">
                Oppure inizia con quella gratuita
              </Link>
            </div>
            <p className="mt-5 text-[11px] text-[#A9D6E5]/70">
              Pagamento sicuro con PayPal (conto PayPal o carta) · Brochure via email in pochi minuti ·
              È attuale e precisa. Ma sei certo di volerlo fare da solo? Dentro trovi anche la risposta.
            </p>
          </div>

          {/* Brochure mockup */}
          <div className="col-span-12 lg:col-span-5">
            <div className="relative max-w-sm mx-auto" data-testid="premium-brochure-mockup">
              <div className="absolute top-4 left-4 right-[-16px] bottom-[-16px] rounded-2xl bg-white/5 border border-white/10" />
              <div className="absolute top-2 left-2 right-[-8px] bottom-[-8px] rounded-2xl bg-white/10 border border-white/10" />
              <div className="relative rounded-2xl bg-gradient-to-br from-[#13315c] to-[#0b2545] border border-[#A9D6E5]/30 shadow-2xl p-7 aspect-[3/4] flex flex-col">
                {launch && (
                  <span className="absolute -top-3 -right-3 rotate-6 rounded-full bg-amber-400 text-[#0b2545] text-[10px] font-black px-3 py-1.5 shadow-lg" data-testid="premium-mockup-launch-tag">
                    🔥 −€{279 - price}
                  </span>
                )}
                <div className="text-[9px] font-semibold uppercase tracking-[0.24em] text-[#A9D6E5]">Gruppo Vela · Copilot AI</div>
                <div className="mt-5 text-3xl font-display font-semibold leading-tight text-white">
                  VALUTAZIONE<br />PREMIUM
                </div>
                <div className="mt-1.5 text-xs font-bold tracking-[0.22em] text-[#14B8A6]">ENEA SPECIALIST</div>
                <div className="mt-auto space-y-2.5">
                  {[
                    [FileText, "11 pagine · 22 fattori analizzati"],
                    [TrendingUp, "Grafico OMI + calcolo in euro"],
                    [ShieldCheck, "Strategia e minimo difendibile"],
                    [Phone, "Call 30 min inclusa"],
                  ].map(([Icon, t]) => (
                    <div key={t} className="flex items-center gap-2.5 text-[11px] text-white/85">
                      <span className="w-6 h-6 rounded-md bg-[#14B8A6]/15 border border-[#14B8A6]/30 flex items-center justify-center">
                        <Icon className="w-3 h-3 text-[#14B8A6]" />
                      </span>
                      {t}
                    </div>
                  ))}
                </div>
                <div className="mt-5 pt-4 border-t border-white/10 flex items-center justify-between">
                  <span className="text-[10px] text-[#A9D6E5]/80">Documento riservato · Metodo MCM</span>
                  <span className="text-sm font-bold text-white bg-[#14B8A6]/20 border border-[#14B8A6]/40 rounded-full px-3 py-1">
                    {launch && <span className="text-[10px] font-normal text-[#A9D6E5]/70 line-through mr-1">€279</span>}€{price}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
